import universalStyles from "./universalStyles.module.css";
const blackButton = universalStyles.blackButton;
const blackButtonOnPaper = universalStyles.blackButtonOnPaper;
const notification = universalStyles.notification;
export { universalStyles, blackButton, blackButtonOnPaper, notification };
export * from './themeOverrides';
